import { createTypedAsyncThunk, withOrgId } from "../utils/actions";
import * as API from "@/data/api/organizations";
import {
  RequestParams,
  TOrganizationInvitationPayload,
  TOrganizationItem,
  TOrganizationPayload,
  TOrganizationUninvitePayload,
  TPlanLedger,
} from "@/data/types";
import { State } from "../state/state";
import { getOrganizationId } from "../selectors";

export const getAllOrganizationsAsync = createTypedAsyncThunk<
  { items: TOrganizationItem[] },
  RequestParams
>("organizations/getAllOrganizations", async (params, { getState }) => {
  return API.getAllOrganizations(withOrgId(getState, params));
});

export const createOrganizationAsync = createTypedAsyncThunk<
  TOrganizationItem,
  { params?: RequestParams; payload: TOrganizationPayload }
>(
  "organizations/createOrganization",
  async ({ params = {}, payload }, { getState }) => {
    return API.createOrganization(withOrgId(getState, params), payload);
  }
);

export const getOrganizationByIdAsync = createTypedAsyncThunk<
  TOrganizationItem,
  { organizationId: string; params?: RequestParams }
>(
  "organizations/getOrganizationById",
  async ({ organizationId, params = {} }, { getState }) => {
    return API.getOrganizationById(organizationId, withOrgId(getState, params));
  }
);

export const getCurrentOrganizationAsync = createTypedAsyncThunk<
  TOrganizationItem,
  { params?: RequestParams }
>(
  "organizations/getCurrentOrganization",
  async ({ params = {} } = {}, { getState }) => {
    return API.getCurrentOrganization(withOrgId(getState, params));
  }
);

export const updateOrganizationAsync = createTypedAsyncThunk<
  TOrganizationItem,
  {
    organizationId: string;
    params?: RequestParams;
    payload: Partial<TOrganizationPayload>;
  }
>(
  "organizations/updateOrganization",
  async ({ organizationId, params = {}, payload }, { getState }) => {
    return API.updateOrganization(
      organizationId,
      withOrgId(getState, params),
      payload
    );
  }
);

export const deleteOrganizationAsync = createTypedAsyncThunk<
  { success: boolean },
  { organizationId: string; params?: RequestParams }
>(
  "organizations/deleteOrganization",
  async ({ organizationId, params = {} }, { getState }) => {
    return API.deleteOrganization(organizationId, withOrgId(getState, params));
  }
);

export const getOrganizationInvitationsAsync = createTypedAsyncThunk<
  any,
  RequestParams
>(
  "organizations/getOrganizationInvitations",
  async (params, { getState }) => {
    return API.getOrganizationInvitations(withOrgId(getState, params));
  }
);

export const createOrganizationInvitationAsync = createTypedAsyncThunk<
  any,
  { params?: RequestParams; payload: TOrganizationInvitationPayload }
>(
  "organizations/createOrganizationInvitation",
  async ({ params = {}, payload }, { getState }) => {
    return API.createOrganizationInvitation(
      withOrgId(getState, params),
      payload
    );
  }
);

export const deleteOrganizationInvitationAsync = createTypedAsyncThunk<
  { success: boolean },
  { params?: RequestParams; payload: TOrganizationUninvitePayload }
>(
  "organizations/deleteOrganizationInvitation",
  async ({ params = {}, payload }, { getState }) => {
    return API.deleteOrganizationInvitation(
      withOrgId(getState, params),
      payload
    );
  }
);

export const getAvailablePlanLedgersAsync = createTypedAsyncThunk<
  TPlanLedger,
  RequestParams | void
>(
  "organizations/getAvailablePlanLedgers",
  async (params, { getState }) => {
    return API.getAvailablePlanLedgers(withOrgId(getState, params || {}));
  }
);
